import type { ApiPerformance, Performance } from '../types/performance';

const adaptPerformance = (apiPerformance: ApiPerformance, horseId: string): Performance => {
  const ranking = apiPerformance.ranking ?? [];
  const runners = apiPerformance.runners ?? [];

  const top3: Performance['top3'] = ranking
    .filter(
      (rankEntry): rankEntry is { rank: number; runnerNumber: number } =>
        rankEntry.rank !== null && rankEntry.rank <= 3
    )
    .sort((rankEntryA, rankEntryB) => rankEntryA.rank - rankEntryB.rank)
    .map(rankEntry => ({
      rank: rankEntry.rank,
      horseName:
        runners.find(runner => runner.runnerNumber === rankEntry.runnerNumber)?.horse?.name ?? null,
    }));

  const horseRunner = runners.find(runner => runner.horse?.funcId === horseId) ?? null;

  return {
    id: apiPerformance.id,
    date: apiPerformance.date,
    racecourse: apiPerformance.racecourse.label,
    raceNumber: apiPerformance.raceNumber,
    trackCondition: apiPerformance.trackCondition?.label ?? null,
    raceType: apiPerformance.raceType?.label ?? null,
    startingMode: apiPerformance.startingMode?.label ?? null,
    runnersCount: apiPerformance.runnersCount,
    distance: apiPerformance.distance,
    rank: horseRunner?.rank ?? null,
    railPosition: horseRunner?.railPosition ?? null,
    timeRecord: horseRunner?.timeRecord ?? null,
    riderName: horseRunner?.rider?.name ?? null,
    totalPool: apiPerformance.earnings?.totalPool ?? null,
    top3,
  };
};

export { adaptPerformance };
